export default __webpack_public_path__ + "static/media/unlocked-img.d09f40cd.svg";